import { RegionEnum, ThemeEnum } from '~/enums/Region'
import getDefaultLocale from '~/utils/locale/getDefaultLocale'
import type { RuntimeConfig } from 'nuxt/schema'
import { H3Event } from 'h3'

export const getCurrentTheme = (event?: H3Event, config?: RuntimeConfig) => {
  const locale = getDefaultLocale(event, config).region

  switch (locale) {
    case RegionEnum.PERKUJAV: {
      return ThemeEnum.PERKUJAV
    }
    case RegionEnum.TARPININKE: {
      return ThemeEnum.TARPININKE
    }
    case RegionEnum.WHITELABEL: {
      return ThemeEnum.WHITELABEL
    }
    case RegionEnum.NORIULIVE: {
      return ThemeEnum.NORIULIVE
    }
    case RegionEnum.AMEERIKAEESTIS: {
      return ThemeEnum.AMEERIKAEESTIS
    }
    case RegionEnum.LV:
    case RegionEnum.EE:
    case RegionEnum.LT:
    default: {
      return ThemeEnum.SHIPZEE
    }
  }
}
